"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var BaseListStore_1 = require("./BaseListStore");
var adsTxtReportApi_1 = require("../api/adsTxtReportApi");
var ADS_TXT_SEARCHABLE_FIELDS = ["domain"];
var AdsTxtReportStore = /** @class */ (function (_super) {
    tslib_1.__extends(AdsTxtReportStore, _super);
    function AdsTxtReportStore(notificationsStore, exportToCsvService) {
        var _this = _super.call(this, notificationsStore, ADS_TXT_SEARCHABLE_FIELDS, "ad txt report", "domain") || this;
        _this.exportToCsvService = exportToCsvService;
        _this.downloadCSV = function () {
            _this.notificationsStore.pushSuccessNotification({
                title: "Generating CSV",
                text: "Please wait...",
                timeout: 5000
            });
            _this.exportToCsvService.exportAdsTxtReport(_this.items);
        };
        _this.getItems = function () {
            if (_this.isLoading) {
                return;
            }
            mobx_1.transaction(function () {
                _this.isLoading = true;
                _this.resetSearchQueries();
            });
            adsTxtReportApi_1.default.getAll(_this.selectedDemandPartners, _this.type)
                .then(function (res) { return _this.onLoadItemsSuccess(res); })
                .catch(function (res) { return _this.onLoadItemsError(res); });
        };
        _this.getDemandPartners = function () {
            adsTxtReportApi_1.default.getDemandPartners()
                .then(function (res) { return _this.onLoadDemandPartnersSuccess(res); })
                .catch(function (res) { return _this.onLoadItemsError(res); });
        };
        _this.selectDemandPartner = function (value) {
            _this.selectedDemandPartners = _this.selectedDemandPartners.concat([value]);
        };
        _this.removeDemandPartner = function (value) {
            _this.selectedDemandPartners = _this.selectedDemandPartners.filter(function (id) { return id !== value; });
        };
        _this.changeType = function (type) {
            _this.type = type;
        };
        return _this;
    }
    AdsTxtReportStore.prototype.reset = function () {
        _super.prototype.reset.call(this);
        this.type = "website";
        this.selectedDemandPartners = mobx_1.observable([]);
    };
    AdsTxtReportStore.prototype.onLoadItemsSuccess = function (res) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.items = res.data;
        });
    };
    AdsTxtReportStore.prototype.onLoadDemandPartnersSuccess = function (res) {
        this.demandPartners = res.data;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], AdsTxtReportStore.prototype, "filterButton", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AdsTxtReportStore.prototype, "demandPartners", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AdsTxtReportStore.prototype, "selectedDemandPartners", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AdsTxtReportStore.prototype, "type", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "downloadCSV", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "getItems", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "onLoadItemsSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "getDemandPartners", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "onLoadDemandPartnersSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "selectDemandPartner", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "removeDemandPartner", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AdsTxtReportStore.prototype, "changeType", void 0);
    return AdsTxtReportStore;
}(BaseListStore_1.default));
exports.default = AdsTxtReportStore;
